// extracted by mini-css-extract-plugin
export var accordion = "accordion-module--accordion--8VJVd";
export var container = "accordion-module--container--2lDt2";
export var detail = "accordion-module--detail--pjSSS";
export var item = "accordion-module--item--9ICtd";
export var title = "accordion-module--title--+p6ku";
export var titleText = "accordion-module--title-text--ozg5b";
export var toggle = "accordion-module--toggle--J-3ZQ";
export var toggleIcon = "accordion-module--toggle-icon--xDfFe";